<template>
  <a-layout-footer style="text-align: center">
    <p>
      ©{{ $config.Year }} - {{ $config["Company Name"] }}. All rights reserved. 版权所有.<br>
      备案号：<a href="http://beian.miit.gov.cn/" target="_blank">{{ $config.ICP }}</a><br>
      联系地址：{{$config["Mail address"]}}&emsp;联系电话：{{$config.Phone}}
    </p>
  </a-layout-footer>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {
      data: {}
    }
  }
}
</script>

<style scoped>

</style>